// We have real-time progress reporting on the upload of the file, but not the subsequent engagement creation.
// This constant represents that when the upload bar reaches 97%,
// that's when the UIAbstractProgress should start optimistically incrementing it to 100%.
// If the UIAbstractProgress started incrementing at 0% instead of 97%, it would work fine in most cases but for a user with a slow connection,
// the progress bar would jump forward optimistically and then backward when it's updated with the real value
export const OPTIMISTIC_PROGRESS_START_PERCENT = 97;
export const PAGE_COUNTS = [10, 25, 100];
export const SOURCE_FILTER_VALUES = {
  NOTE: 'NOTE',
  TASK: 'TASK',
  MEETING: 'MEETING',
  CALL: 'CALL',
  EMAIL: 'EMAIL',
  CONVERSATION_SESSION: 'CONVERSATION_SESSION',
  SMS: 'SMS',
  WHATS_APP: 'WHATS_APP',
  LINKEDIN_MESSAGE: 'LINKEDIN_MESSAGE',
  DIRECT_UPLOAD: 'DIRECT_UPLOAD'
};

/*
 * Constants mapped from:
     https://git.hubteam.com/HubSpot/CrmRecordAttachments/blob/master/CrmRecordAttachmentsCore/src/main/java/com/hubspot/crm/record/attachments/core/AttachmentConstants.java
 * Which is derived from:
     https://git.hubteam.com/HubSpot/Engagements/blob/master/EngagementsBase/src/main/java/com/hubspot/engagements/base/detail/EngagementType.java#L36-L36
 * The INCOMING_EMAIL and FORWARDED_EMAIL constants are consolidated to just EMAIL in the UI
 */
export const SOURCE_RAW_VALUES = Object.assign({}, SOURCE_FILTER_VALUES, {
  INCOMING_EMAIL: 'INCOMING_EMAIL',
  FORWARDED_EMAIL: 'FORWARDED_EMAIL'
});
export const FILTER_FILE_VALUES = {
  VIDEOS: 'VIDEOS',
  IMAGES: 'IMAGES',
  DOCUMENTS: 'DOCUMENTS',
  AUDIO: 'AUDIO'
};

// We should use the same bucketing as Files Manager Dashboard, which is specified at
// https://git.hubteam.com/HubSpot/FileManager/blob/52456d423a86d5bad44ecb2539a1a1e760000b1c/FileManagerData/src/main/java/com/hubspot/content/filemanager/data/files/FileFormats.java#L57
// This const should stay in sync with that
export const FILTER_FILE_MAP = {
  [FILTER_FILE_VALUES.VIDEOS]: ['3g2', '3gp', 'asf', 'asx', 'avi', 'divx', 'f4v', 'flv', 'm4v', 'mkv', 'mov', 'mp4', 'mpg', 'mpeg', 'ogv', 'qt', 'rm', 'swf', 'webm', 'wmv'],
  [FILTER_FILE_VALUES.IMAGES]: ['bmp', 'ico', 'gif', 'jpeg', 'jpg', 'png', 'svg', 'tif', 'tiff', 'webp'],
  [FILTER_FILE_VALUES.DOCUMENTS]: ['csv', 'doc', 'docx', 'dot', 'dotx', 'key', 'pdf', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptx', 'txt', 'wpd', 'wps', 'wri', 'xls', 'xlsb', 'xlsx', 'xlt', 'xlx', 'xml'],
  [FILTER_FILE_VALUES.AUDIO]: ['aac', 'aif', 'amr', 'm4a', 'mp3', 'mpa', 'oga', 'opus', 'ra', 'wav', 'wma']
};

// This is the max the endpoint will support
export const MAX_FETCH_ATTACHMENTS_COUNT = 500;
export const SHOW_MORE_INCREMENT = 5;

// An offset beyond 10k will cause the endpoint to return an error
export const MAX_FETCH_ATTACHMENTS_OFFSET = 10000;
export const ATTACHMENT_QUERY_SOURCE = {
  CARD: 'CARD',
  MODAL: 'MODAL'
};